import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
export default class DuplicateWarningModal extends Modal {
  className() {
    return 'DuplicateWarningModal Modal--medium';
  }
  title() {
    return m("span", null, m("i", {
      className: "fas fa-exclamation-triangle",
      style: {
        color: '#e53935',
        marginRight: '8px'
      }
    }), app.translator.trans('nagusi-match-ratings.forum.duplicates.modal_title') || '¿Hilo similar ya existente?');
  }
  content() {
    const matches = this.attrs.matches || [];
    const topMatch = matches[0];
    return m("div", {
      className: "Modal-body DuplicateWarningModal-body"
    }, m("p", {
      className: "DuplicateWarningModal-intro"
    }, app.translator.trans('nagusi-match-ratings.forum.duplicates.modal_intro') || 'Hemos detectado que ya existen hilos muy similares creados recientemente en el foro:'), m("div", {
      className: "DuplicateWarningModal-list"
    }, matches.map(item => m("div", {
      className: "DuplicateWarningModal-item",
      key: item.id
    }, m("div", {
      className: "DuplicateWarningModal-itemHeader"
    }, m("a", {
      href: app.route('discussion', {
        id: "".concat(item.id).concat(item.slug ? '-' + item.slug : '')
      }),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "DuplicateWarningModal-itemTitle"
    }, m("i", {
      className: "fas fa-external-link-alt",
      style: {
        marginRight: '6px',
        fontSize: '0.85em'
      }
    }), item.title), item.tag && m("span", {
      className: "DuplicateWarningModal-tag",
      style: {
        backgroundColor: item.tag.color || '#717171'
      }
    }, item.tag.name)), m("div", {
      className: "DuplicateWarningModal-itemMeta"
    }, m("span", null, m("i", {
      className: "far fa-comment",
      style: {
        marginRight: '4px'
      }
    }), item.commentCount, " ", item.commentCount === 1 ? 'comentario' : 'comentarios'), m("span", null, " \xB7 "), m("span", null, "\xDAltima respuesta por ", m("strong", null, item.lastPostedUser)), m("span", {
      className: "DuplicateWarningModal-similarityBadge"
    }, Math.round(item.similarity), "% coincidencia"))))), m("p", {
      className: "DuplicateWarningModal-help"
    }, "Te recomendamos unirte a la conversaci\xF3n en el hilo ya abierto para evitar dispersar las opiniones."), m("div", {
      className: "DuplicateWarningModal-actions"
    }, topMatch && m("a", {
      className: "Button Button--primary DuplicateWarningModal-goToDiscussion",
      href: app.route('discussion', {
        id: "".concat(topMatch.id).concat(topMatch.slug ? '-' + topMatch.slug : '')
      }),
      target: "_blank",
      rel: "noopener noreferrer",
      onclick: () => this.hide()
    }, m("i", {
      className: "fas fa-comments",
      style: {
        marginRight: '6px'
      }
    }), "Ir al hilo existente"), m(Button, {
      className: "Button Button--danger-ghost DuplicateWarningModal-forceSubmit",
      onclick: () => {
        this.hide();
        if (typeof this.attrs.onConfirm === 'function') {
          this.attrs.onConfirm();
        }
      }
    }, "Publicar de todas formas")));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/duplicates/DuplicateWarningModal', DuplicateWarningModal);